import React from 'react';
import {Table, TableBody, TableContainer, TableHead, TableHeader, TableRow, TableToolbar, DataTable } from 'carbon-components-react';
import DependentsTableRow from './dependent-table-row';
import BeneficiaryTableRow from './beneficiary-table-row';
import { BeneficiaryType } from '../../components/enums/beneficiary-type';

const DependentsTable = ({modifiedArray, unmodifiedArray, isBeneficaries, type}) => {
    const headers = isBeneficaries ? [
        {key: "first", header: "First"},
        {key: "last", header: "Last"},
        {key: "relationship", header: "Relationship" },
        {key: "ssn", header: "SSN" },
        {key: "address", header: "Address" },
        {key: "percentOfBenefit", header: "% of Benefit" },
        {key: "type", header: "Type" },
  
    ] :[
        {key: "first", header: "First"},
        {key: "last", header: "Last"},
        {key: "ssn", header: "SSN"},
        {key: "birthdate", header: "Date of Birth"},
        {key: "gender", header: "Gender"},
        {key: "relationship", header: "Relationship"}, 
    ]
    return (                     
        <DataTable headers={headers} rows={[]} >
        {() => (
            <TableContainer>
                {isBeneficaries ?
                    <TableToolbar>
                        <h4 className='my-2 pl-2 whitespace-nowrap'>{type === BeneficiaryType.Primary ? "Primary" : "Contingent"}</h4>
                    </TableToolbar>
                    :<></>
                }
                <Table>
                    <TableHead >
                        <TableRow >
                            {headers.map((header, idx) => (
                                <TableHeader key={idx} className="p-4">
                                    {header.header}
                                </TableHeader>
                            ))}
                            <TableHeader></TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {modifiedArray.map((modified) => {
                        const unmodified = unmodifiedArray?.find(s => s.id === modified.id);
                    return(<TableRow key={modified.id}>
                            {isBeneficaries ?
                                <BeneficiaryTableRow modified={modified} unmodified={unmodified}  />
                            :
                                <DependentsTableRow modified={modified} unmodified={unmodified}  />
                            }
                    </TableRow>
                    );
                    })}

                    {
                        unmodifiedArray?.filter(o=> !modifiedArray.some(i=> i.id === o.id)).map((removed) => {
                            return(<TableRow key={removed.id}>
                                {isBeneficaries ?
                                <BeneficiaryTableRow  modified={null} unmodified={removed}  />
                            :
                                <DependentsTableRow modified={null} unmodified={removed}  />
                            }
                            </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        )}
    </DataTable>
    );
}
 
export default DependentsTable;